module.exports = __webpack_public_path__ + "static/media/feedback-colored.733cab91.svg";